import { computed } from 'vue'
import { validLength } from '../api/checker'

export default function ( notice ){

  const noticeValidator = () =>{
    console.log( "noticeValidator" )
	return validLength(1, 1000, notice.value.contents)
  }
  
  //computed�ɐݒ�
  //�e���ڂ̓��͂��ω������ۂɏ������N��
  //�S�`�F�b�N�͓o�^�{�^�������ۂɎg�p����
  const resNoticeVal = computed( noticeValidator )

  //���Y���W���[�����񋟂���ϐ��A���\�b�h��錾
  return{
	resNoticeVal
  }
}